/*
 * Alertas de calidad del dashboard: jornadas incompletas por tipo (entrada sin salida de días pasados,
 * salida sin entrada, almuerzo sin inicio o fin, marcas en orden imposible) y el detalle más reciente.
 * No suman horas ni promedios; sirven para corregir marcas. Consume `alertas` {total, por_tipo, detalle}:
 * `total` es el conteo REAL y `detalle` viene recortado por el servidor (máx. 50, más recientes primero);
 * el rótulo sale de alertsCountText y la fecha de alertDayLabel (con año si el rango cruza años). El detalle
 * inicia con 10 filas y se despliega completo. Solo se muestran nombre, tienda, zona, fecha y descripción.
 */
import React, {useState} from "react";
import EmployeeName from "../../components/EmployeeName";
import StatusBadge from "../../components/StatusBadge";
import {alertDayLabel, alertsCountText} from "../../utils/dashboard";

const DETAIL_ROWS = 10;

const AlertsPanel = ({alertas, range}) => {
    const [expanded, setExpanded] = useState(false);
    const detalle = alertas.detalle || [];
    const shown = expanded ? detalle : detalle.slice(0, DETAIL_ROWS);
    return (
        <div className="mc-panel">
            <h3 className="mc-panel__title">Alertas de calidad</h3>
            {alertas.total === 0 ? (
                <p className="mc-inline-empty">Sin marcas incompletas en este rango.</p>
            ) : (
                <>
                    <ul className="mc-chips">
                        {alertas.por_tipo.filter((row) => row.cantidad > 0).map((row) => (
                            <li key={row.problema} className="mc-badge mc-badge--down">
                                <i className="bx bx-error-circle" aria-hidden="true"/>
                                {row.descripcion}: <strong className="mc-num">{row.cantidad}</strong>
                            </li>
                        ))}
                    </ul>
                    <ul className="mc-list">
                        {shown.map((row) => (
                            <li key={`${row.fecha}-${row.id_empleado}`} className="mc-list__item">
                                <EmployeeName row={row}/>
                                <span className="mc-list__time"><small>{alertDayLabel(row.fecha, range)}</small></span>
                                <StatusBadge tone="down" text={row.descripcion}/>
                            </li>
                        ))}
                    </ul>
                    <p className="mc-panel__hint">{alertsCountText(alertas.total, shown.length, detalle.length)}</p>
                    {detalle.length > DETAIL_ROWS &&
                        <button type="button" className="btn btn-link btn-sm mc-clear" aria-expanded={expanded}
                                onClick={() => setExpanded(!expanded)}>
                            {expanded ? 'Ver solo las 10 más recientes' : `Ver las ${detalle.length} más recientes`}
                        </button>}
                </>
            )}
        </div>
    );
};

export default AlertsPanel;
